import { render, staticRenderFns } from "./SmartObjectSuggestionList.vue?vue&type=template&id=da5e62bc&scoped=true"
import script from "./SmartObjectSuggestionList.vue?vue&type=script&lang=js"
export * from "./SmartObjectSuggestionList.vue?vue&type=script&lang=js"
import style0 from "./SmartObjectSuggestionList.vue?vue&type=style&index=0&id=da5e62bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e62bc",
  null
  
)

export default component.exports